import { render, staticRenderFns } from "./settingv1.vue?vue&type=template&id=1edc044a&scoped=true"
import script from "./settingv1.vue?vue&type=script&lang=ts"
export * from "./settingv1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc044a",
  null
  
)

export default component.exports